export default "__VITE_ASSET__DpNCLTB5__"